import { Observable } from 'rxjs';
import { IArticleVariant, IOutletStoreArticle } from '../interfaces';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ISimpleListItem } from '../interfaces/ISimpleListItem';
import { ApiService } from '../../../../core/services';
import { GenericService } from '../../../../core/services/GenericService';

@Injectable({
  providedIn: 'root'
})
export class ArticlesVariantsService extends GenericService<IArticleVariant> {

  protected readonly baseUrl = '/labels/articles';

  constructor(
    public apiService: ApiService
  ) {
    super(apiService);
  }

  getSimpleList( search = ''): Observable<ISimpleListItem[]> {
    let params = new HttpParams().append('results', '50');

    if (search !== '') {
      params = params.append('search', `${search}`);
    }

    return this.apiService.get(`${this.baseUrl}/simple`, params);
  }

  public generateLabel(id: number): Observable<any> {
    return this.apiService.post(`${ this.baseUrl }/${id}/generate-label`);
  }

  public getOutletStoreArticlesByIds(articlesIds: number[]): Observable<IOutletStoreArticle[]> {
    let params = new HttpParams();
    articlesIds.forEach(id => params = params.append('ids', id.toString()));

    return this.apiService.get(`${ this.baseUrl }/outlet-store`, params);
  }

  public generateOutletStoreLabel(articles: IOutletStoreArticle[], copies = 1): Observable<{ labelKey: string }> {
    const body = {
      outletStoreLabels: articles,
      copies
    };
    return this.apiService.post(`${ this.baseUrl }/outlet-store/generate-label`, body);
  }

  public delete(id: string): Observable<IArticleVariant> {
    throw new Error('HTTP method not implemented.');
  }

  public create(object: IArticleVariant): Observable<void> {
    throw new Error('HTTP method not implemented.');
  }
}
